<script setup>
import './assets/styles/global.styl'
</script>

<template>
  <router-view />
</template>

<style>
</style>
